import { HTMLAttributes } from 'react'

import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'
import { SalesPointCategory } from '@/types/sales-network'

export type FiltersLineNetworkProps = HTMLAttributes<HTMLDivElement> & {
  categories: SalesPointCategory[]
  selectedCategories: number[]
  counts?: Record<number, number>
  onCategorySelect: (_categoryId: number) => void
}

const FiltersLineNetwork = ({
  categories,
  selectedCategories,
  // counts,
  onCategorySelect,
  className,
  ...props
}: FiltersLineNetworkProps) => {
  const { strings } = useStore()

  return (
    <div
      role="group"
      aria-label={strings?.labels?.store_filters || 'Filtri punti vendita'}
      className={cn('flex flex-row flex-wrap gap-spacing-2xs', className)}
      data-filters-line-network
      {...props}
    >
      {categories.map((category) => {
        const isSelected = selectedCategories.includes(category.term_id)
        // const count = counts?.[category.term_id] ?? 0

        return (
          <button
            key={category.term_id}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onCategorySelect(category.term_id)}
            className={cn(
              'flex h-[3.2rem] items-center gap-spacing-2xs border border-[rgba(255,255,255,0.3)] px-spacing-2xs transition-all duration-300 md:gap-spacing-xs',
              isSelected && 'bg-[#F2F2F2]'
            )}
          >
            <Typography
              variant="regular"
              className={cn(
                'condensed text-text-secondary-dark transition-all duration-300',
                isSelected && 'text-text-button-primary-dark'
              )}
            >
              {category.name}
            </Typography>
            {/*  {counts !== undefined && (
              <span
                className={cn(
                  'transition-all duration-300',
                  'flex items-center justify-center rounded-radius-minimal bg-[white] p-spacing-2xs text-text-heading-invert-dark',
                  {
                    'bg-surface-primay-invert-dark text-text-heading-invert-light':
                      isSelected
                  }
                )}
              >
                <Typography
                  variant="small"
                  component="span"
                  className={cn('condensed tabular-nums')}
                >
                  {count}
                </Typography>
              </span>
            )} */}
          </button>
        )
      })}
    </div>
  )
}

export default FiltersLineNetwork
